import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import { CardVerification, CardVerificationApprove } from './types'
import { $params } from '../../../features/router'
import { cardVerificationStatus } from '../const'
import { setRequestSuccess, setRequestError } from '../../../features/notifications'

export const cardVerificationRequestMounted = createEvent()
export const setCardVerificationRequest = createEvent<CardVerification>()
export const submitApprove = createEvent<CardVerificationApprove>()

export const submitEditCardVerificationRequest = createEvent<CardVerification>()

export const $cardVerificationRequest = restore(setCardVerificationRequest, {
  requestId: '0',
  clientId: '0',
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  status: '',
  country: '',
  city: '',
  address: '',
  zip: '',
  documentType: '',
  documentNumber: '',
  fileNames: [],
  browserFileNames: [],
  exampleFiles: '',
  expirationDate: '',
  duplicate: false,
  hasDeposit: false,
  profileNotes: '',
  comment: '',
  manager: '',
  client: {
    clientId: '',
    email: '',
    fullName: '',
    partner: false,
    verified: false,
  },
})

export const getCardVerification = fx<void, CardVerification>({
  method: 'GET',
  url: `/cardVerification/`,
})

sample({
  clock: cardVerificationRequestMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.cardVerificationID
    }
    return {
      url: `/cardVerification/${id}`,
    }
  },
  target: getCardVerification,
})

export const approveCardVerification = fx<
  CardVerificationApprove,
  CardVerification
>({
  method: 'PUT',
  url: `/cardVerification/`,
})

sample({
  clock: submitApprove,
  fn: (cardVerification) => {
    cardVerification.status =
      cardVerificationStatus.cardVerificationRequestStatusAccepted()
    return {
      body: { ...cardVerification },
      url: `/cardVerification/${cardVerification.requestId}`,
    }
  },
  target: approveCardVerification,
})

export const updateCardVerificationRequest = fx<
  CardVerification,
  CardVerification
>({
  method: 'PUT',
  url: '/cardVerification/',
})

sample({
  clock: submitEditCardVerificationRequest,
  source: $params,
  fn: (params, cardVerification) => {
    return {
      url: `/cardVerification/${cardVerification.requestId}`,
      body: { ...cardVerification },
    }
  },
  target: updateCardVerificationRequest,
})

sample({
  clock: getCardVerification.doneData,
  fn: (doneData) => doneData.body,
  target: setCardVerificationRequest,
})

sample({
  clock: approveCardVerification.doneData,
  fn: (doneData) => doneData.body,
  target: setCardVerificationRequest,
})

sample({
  clock: approveCardVerification.done,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: approveCardVerification.fail,
  fn: ({ error }) => ({
    message: (error as any)?.body?.message || (error as any)?.message || 'Unknown error',
    code: (error as any)?.status || 0,
  }),
  target: setRequestError,
})
